import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { getThemeColors, THEME_OPTIONS } from '../theme'

const CHANGELOG = [
  {
    date: '2026-04-24',
    title: 'Mejoras en sugerencias y control de costo',
    feedback: 'Usuarios reportaron que al cambiar CV no se actualizaban bien keywords y que habia consumo excesivo de IA.',
    changes: [
      'Re-sugerencia de keywords al reemplazar CV.',
      'Objetivo configurable de cantidad de keywords por usuario.',
      'Cache por hash de CV para no recalcular IA si el CV no cambio.',
      'Mejor mensaje operativo cuando se reutilizan sugerencias existentes.',
    ],
  },
  {
    date: '2026-04-24',
    title: 'Experiencia de cuenta y visibilidad en configuracion',
    feedback: 'Se pidio claridad sobre que CV esta activo y mejor control en configuracion.',
    changes: [
      'Bloque de CV restaurado en Configuracion (subir/reemplazar/quitar).',
      'Nombre del CV visible de forma persistente para que el usuario sepa cual esta activo.',
      'Ajustes de UX para reducir confusion en acciones de perfil.',
    ],
  },
  {
    date: '2026-04-24',
    title: 'Mejoras generales de experiencia y navegacion',
    feedback: 'Se recibio retroalimentacion sobre consistencia visual y comportamiento de navegacion en distintos dispositivos.',
    changes: [
      'Ajustes de responsive para una lectura mas comoda en pantallas pequenas.',
      'Mejoras generales de espaciado y distribucion visual para evitar recortes.',
      'Navegacion corregida para iniciar cada pagina desde la parte superior al cambiar de seccion.',
    ],
  },
]

const formatDateEs = (value) => {
  const date = new Date(`${value}T00:00:00`)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })
}

export default function Cambios({ session, theme = THEME_OPTIONS.LIGHT }) {
  const C = getThemeColors(theme)

  return (
    <div style={{ minHeight: '100vh', background: C.bg, color: C.text, fontFamily: "'DM Sans', system-ui, sans-serif" }}>
      <Header theme={theme} session={session} perfil={null} />

      <main style={{ maxWidth: '860px', margin: '0 auto', padding: '32px 20px', boxSizing: 'border-box' }}>
        <div style={{ marginBottom: '20px' }}>
          <h1 style={{ margin: 0, fontSize: '30px', letterSpacing: '-0.6px' }}>Historial de cambios</h1>
          <p style={{ margin: '8px 0 0', color: C.subtle, fontSize: '14px', lineHeight: '1.7' }}>
            Este registro resume mejoras realizadas con base en retroalimentacion de usuarios de la beta.
          </p>
        </div>

        <div style={{ display: 'grid', gap: '14px' }}>
          {CHANGELOG.map((entry) => (
            <article key={`${entry.date}-${entry.title}`} style={{ background: C.white, border: `0.5px solid ${C.border}`, borderRadius: '14px', padding: '18px' }}>
              <div style={{ fontSize: '12px', color: C.subtle, marginBottom: '6px' }}>{formatDateEs(entry.date)}</div>
              <div style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>{entry.title}</div>
              <div style={{ fontSize: '13px', color: C.muted, marginBottom: '10px', lineHeight: '1.6' }}>
                <strong>Feedback recibido:</strong> {entry.feedback}
              </div>
              <ul style={{ margin: 0, paddingLeft: '18px', color: C.text, fontSize: '13px', lineHeight: '1.8' }}>
                {entry.changes.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </main>

      <div style={{ maxWidth: '860px', margin: '0 auto', padding: '0 20px 24px', boxSizing: 'border-box' }}>
        <Footer theme={theme} />
      </div>
    </div>
  )
}
